if (!customElements.get('testimonials-navigation')) {
  customElements.define('testimonials-navigation', class TestimonialsNavigation extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('[data-section-type="testimonials"]');
    }

    connectedCallback() {
      this.init();
    }

    init(retry = 1, maxRetry = 10) {
      if (retry === maxRetry) {
        return;
      }

      if (!this.section || !this.section._testimonialsFlickity) {
        setTimeout(() => {
          this.init(retry + 1);
        }, 100);
        return;
      }

      this.flickity = this.section._testimonialsFlickity;
      const buttons = this.querySelectorAll('.testimonials-pagination-dot');

      this.flickity.on('select', () => {
        buttons.forEach(button => {
          button.classList.remove('is-active');
        });

        if (buttons[this.flickity.selectedIndex]) {
          buttons[this.flickity.selectedIndex].classList.add('is-active');
        }
      });

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.flickity.select(index);
        });
      });

      if (buttons[0]) {
        buttons[0].classList.add('is-active');
      }
    }
  });
}

